<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('common_words.associated_sub_category_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-11 p-0">
        <span v-for="index in sub_number" :key="index">
          <card class="custom-audit-card shadow-sm">
            <div class="row">
              <div class="col-1 col-sm-2 col-xl-1 pr-0">
                <fg-input
                  style="width: 65px"
                  type="number"
                  class="required-second-step"
                  :label="$t('common_words.order_request')"
                  :min="1"
                  v-model.number="model.subcategoryOrder[index - 1]"
                  placeholder="1"
                ></fg-input>
              </div>
              <div class="col-12 col-sm-10 col-md-5 col-lg-5 col-xl-5">
                <fg-input
                  type="text"
                  class="required-second-step"
                  :label="`${$t('common_words.sub_category_name')}: *`"
                  v-model="model.sub_category_names[index - 1]"
                  :placeholder="`${$t('common_words.sub_category_name')}...`"
                  @blur="updateSubCat"
                ></fg-input>
              </div>
              <div class="col-4 col-sm-2 col-md-2 col-xl-1">
                <label>{{ $t('common_words.general') }}?</label>
                <br />
                <l-switch
                  class="mt-2"
                  style="display: block"
                  v-model="model.isGeneral[index - 1]"
                  on-text="SI"
                  off-text="NO"
                  :index="index - 1"
                >
                </l-switch>
              </div>
              <div class="col-4 col-sm-2 col-md-2 col-xl-1">
                <label>{{ $t('common_words.formula') }}?</label>
                <br />
                <l-switch
                  class="mt-2"
                  style="display: block"
                  v-model="model.allowFormula[index - 1]"
                  on-text="SI"
                  off-text="NO"
                  :index="index - 1"
                >
                </l-switch>
              </div>
              <div class="col-8 col-sm-10 col-md-7 col-lg-4 col-xl-2">
                <fg-input
                  min="0"
                  max="100"
                  type="number"
                  step=".02"
                  :label="`${$t('common_words.value_percentage_symbol').replace(
                    /[()]/g,
                    ''
                  )}`"
                  v-model="model.valuePercentage[index - 1]"
                  placeholder="0.02"
                  :name="`common_words.sub_category_percentual_value`"
                  v-validate="modelValidations.valuePercentage"
                  :error="
                    getError(
                      `common_words.sub_category_percentual_value`,
                      true,
                      index
                    )
                  "
                  @change="updatePercentage(index - 1)"
                ></fg-input>
              </div>
              <div class="col-12 col-xs-4 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                <div class="form-group grid-without-label" style="white-space: nowrap;">
                  <el-button
                    v-tooltip.top-center="$t('common_words.add_task')"
                    class="btn-secondary button-new-tag"
                    size="small"
                    @click="addTask(index - 1)"
                    icon="el-icon-plus"
                  >
                  </el-button>
                  <el-button
                    v-if="model.tasks_number[index - 1] > 0"
                    v-tooltip.top-center="$t('common_words.delete_task')"
                    class="btn-secondary button-new-tag"
                    size="small"
                    @click="minusTask(index - 1)"
                    icon="el-icon-minus"
                  >
                  </el-button>
                </div>
              </div>
            </div>
            <el-divider
              v-if="model.tasks_number[index - 1]"
              content-position="left"
              >{{ $t('common_words.tasks_fill') }}</el-divider
            >
            <div class="row">
              <div class="col-12">
                <span v-for="i in model.tasks_number[index - 1]" :key="i">
                  <div class="row mt-3">
                    <div class="col col-lg-1 col-xl-1 fs-13-label">
                      <!-- style="width: 65px" -->
                      <fg-input
                        type="number"
                        class="required-second-step"
                        :label="$t('common_words.order_request')"
                        placeholder="1"
                        :min="1"
                        v-model.number="
                          model.task_order[index - 1 + '-' + (i - 1)]
                        "
                      ></fg-input>
                    </div>
                    <div
                      class="col-xs-12 col-md-5 col-lg-3 col-xl-2 fs-13-label"
                    >
                      <fg-input
                        class="required-second-step"
                        v-model="model.task_names[index - 1 + '-' + (i - 1)]"
                        type="text"
                        :label="$t('common_words.name_of_the_task')"
                        :placeholder="`${$t(
                          'common_words.task_number_symbol'
                        )}  ${i}`"
                        :error="taskNameErrors[index - 1 + '-' + (i - 1)]"
                        @input="validateAllTaskNames"
                        @blur="updateTasks(index - 1)"
                      ></fg-input>
                    </div>
                    <div
                      class="col-xs-12 col-sm-6 col-md-5 col-lg-4 col-xl-2 fs-13-label"
                    >
                      <div class="form-group has-label">
                        <label>{{ $t('common_words.type_grade') }}</label>
                        <br />
                        <el-select
                          clearable
                          filterable
                          class="select-default shadow-sm required-second-step"
                          v-model="
                            model.calification_type[index - 1 + '-' + (i - 1)]
                          "
                          @change="updateIndexCalificationType"
                          :placeholder="`${$t('common_words.select')}...`"
                        >
                          <el-option
                            v-for="(option, key) in getOptionsCalificationType(index - 1)"
                            :key="key"
                            class="select-default"
                            :label="option.label"
                            :value="option.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div
                      class="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 fs-13-label"
                      v-if="model.allowFormula && model.allowFormula[index - 1]"
                    >
                      <fg-input
                        v-model="model.reference_name[index - 1 + '-' + (i - 1)]"
                        type="text"
                        :label="$t('common_words.reference_ex')"
                        placeholder="Opcional"
                        :error="referenceErrors[index - 1 + '-' + (i - 1)]"
                        @input="validateAllReferences"
                      ></fg-input>
                    </div>
                    <div
                      class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-5 fs-13-label"
                      v-if="model.calification_type[index - 1 + '-' + (i - 1)] === 'Fórmula'"
                    >
                      <div class="form-group has-label">
                        <label>{{ $t('common_words.formula') }}</label>
                        <br />
                        <textarea
                          class="form-control shadow-sm"
                          :class="{ 'custom-has-error': errors.has('formula_' + (index - 1) + '_' + (i - 1)) || formulaErrors[index - 1 + '-' + (i - 1)] }"
                          v-validate="'required'"
                          :name="'formula_' + (index - 1) + '_' + (i - 1)"
                          :data-vv-as="$t('common_words.formula')"
                          rows="2"
                          style="resize: none"
                          v-model="model.formula_expression[index - 1 + '-' + (i - 1)]"
                          @input="
                            val => {
                              let txt = val.target.value;
                              if (txt && txt.includes('=')) {
                                txt = txt.replace(/=/g, '');
                              }
                              $set(model.formula_expression, index - 1 + '-' + (i - 1), txt);
                              validateFormula(txt, index - 1 + '-' + (i - 1));
                            }
                          "
                          placeholder="T1+T2"
                        ></textarea>
                        <div class="mt-2" v-if="getAvailableReferences().length > 0">
                          <small class="text-muted d-block mb-2 font-weight-bold">Variables disponibles (clic para insertar):</small>
                          <div class="d-flex flex-wrap" style="gap: 5px;">
                            <el-tooltip
                              v-for="refObj in getAvailableReferences()" 
                              :key="refObj.name"
                              effect="dark"
                              :content="refObj.taskName ? refObj.taskName : 'Variable sin nombre'"
                              placement="top"
                              :disabled="!refObj.taskName"
                            >
                              <button 
                                type="button"
                                class="btn btn-sm btn-success btn-outline"
                                style="padding: 2px 10px; font-weight: 600;"
                                @click="insertIntoFormula(index - 1, i - 1, refObj.name)"
                              >
                                {{ refObj.name }}
                              </button>
                            </el-tooltip>
                          </div>
                        </div>
                        <div class="mt-2">
                          <small class="text-muted d-block mb-2 font-weight-bold">Operadores Matemáticos:</small>
                          <div class="d-flex flex-wrap" style="gap: 5px;">
                            <button type="button" class="btn btn-sm btn-outline-secondary font-weight-bold" style="padding: 2px 10px;" @click="insertIntoFormula(index - 1, i - 1, '+')">+</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary font-weight-bold" style="padding: 2px 10px;" @click="insertIntoFormula(index - 1, i - 1, '-')">-</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary font-weight-bold" style="padding: 2px 10px;" @click="insertIntoFormula(index - 1, i - 1, '*')">*</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary font-weight-bold" style="padding: 2px 10px;" @click="insertIntoFormula(index - 1, i - 1, '/')">/</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary font-weight-bold" style="padding: 2px 10px;" @click="insertIntoFormula(index - 1, i - 1, '(')">(</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary font-weight-bold" style="padding: 2px 10px;" @click="insertIntoFormula(index - 1, i - 1, ')')">)</button>
                          </div>
                        </div>
                        <div
                          v-if="errors.has('formula_' + (index - 1) + '_' + (i - 1))"
                          class="text-danger invalid-feedback"
                          style="display: block; margin-top: .25rem; font-size: 80%;"
                        >
                          {{ errors.first('formula_' + (index - 1) + '_' + (i - 1)) }}
                        </div>
                        <div
                          v-if="formulaErrors[index - 1 + '-' + (i - 1)]"
                          class="text-danger invalid-feedback"
                          style="display: block; margin-top: .25rem; font-size: 80%;"
                        >
                          {{ formulaErrors[index - 1 + '-' + (i - 1)] }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-2 fs-13-label"
                      v-if="
                        [
                          'Fuente de Datos',
                          'Fuente de Datos Múltiple',
                        ].includes(
                          model.calification_type[index - 1 + '-' + (i - 1)]
                        )
                      "
                    >
                      <div class="form-group has-label">
                        <label>{{
                          $t('common_words.select_data_source')
                        }}</label>
                        <br />
                        <el-select
                          multiple
                          :multiple-limit="1"
                          clearable
                          filterable
                          class="select-default shadow-sm"
                          v-model="model.task_values[index - 1 + '-' + (i - 1)]"
                          :placeholder="`${$t('common_words.select')}...`"
                          @change="
                            fillTableNameSelected(index - 1 + '-' + (i - 1))
                          "
                        >
                          <el-option
                            v-for="(option, key) in dataSources"
                            :key="key"
                            class="select-default"
                            :label="option.label"
                            :value="option.table_name"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div
                      v-else-if="
                        model.calification_type[index - 1 + '-' + (i - 1)] &&
                        ![
                          'Fecha',
                          'Hora',
                          'Objetiva',
                          'Subjetiva',
                          'Subjetiva 2',
                          'Numérica',
                          'Texto',
                          'Fuente de Datos',
                          'Fuente de Datos Múltiple',
                          'Fórmula'
                        ].includes(
                          model.calification_type[index - 1 + '-' + (i - 1)]
                        )
                      "
                      class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-2 fs-13-label"
                    >
                      <label style="margin-bottom: 8px"
                        >{{ $t('common_words.add_values') }}:</label
                      >
                      <br />
                      <div style="margin-left: -10px">
                        <el-tag
                          :key="j"
                          v-for="(tag, j) in model.task_values[
                            index - 1 + '-' + (i - 1)
                          ]"
                          closable
                          type="info"
                          :disable-transitions="false"
                          @close="handleClose(tag, index - 1 + '-' + (i - 1))"
                        >
                          {{ tag }}
                        </el-tag>
                        <el-input
                          class="input-new-tag"
                          v-if="isVisible(index - 1 + '-' + (i - 1))"
                          v-model="input_task_values[index - 1 + '-' + (i - 1)]"
                          :ref="'saveTagInput' + (index - 1 + '-' + (i - 1))"
                          size=""
                          @keyup.enter.native="
                            handleInputConfirm(index - 1 + '-' + (i - 1))
                          "
                          @blur="handleInputConfirm(index - 1 + '-' + (i - 1))"
                        >
                        </el-input>
                        <el-button
                          v-tooltip.top-center="$t('common_words.add_value')"
                          v-else
                          class="btn-secondary button-new-tag"
                          size="small"
                          @click="showInput(index - 1 + '-' + (i - 1))"
                          icon="el-icon-plus"
                        >
                        </el-button>
                      </div>
                    </div>
                    <div
                      class="text-center col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                      v-else-if="
                        ['Numérica', 'Texto'].includes(
                          model.calification_type[index - 1 + '-' + (i - 1)]
                        )
                      "
                    >
                      <div class="row mt-1">
                        <div class="col-6 fs-13-label">
                          <label class="float-left">
                            {{
                              model.calification_type[
                                index - 1 + '-' + (i - 1)
                              ] == 'Texto'
                                ? `Min caracteres`
                                : `Mínimo`
                            }}
                          </label>
                          <input
                            type="number"
                            class="form-control shadow-sm"
                            v-bind:step="`${
                              model.calification_type[
                                index - 1 + '-' + (i - 1)
                              ] == 'Texto'
                                ? `1`
                                : `.01`
                            }`"
                            v-bind:placeholder="`${
                              model.calification_type[
                                index - 1 + '-' + (i - 1)
                              ] == 'Texto'
                                ? `0`
                                : `0.0`
                            }`"
                            v-bind:min="`${
                              model.calification_type[
                                index - 1 + '-' + (i - 1)
                              ] == 'Texto'
                                ? 0
                                : ''
                            }`"
                            v-bind:ref="'minimum'"
                            v-model="
                              model.task_numeric_values[
                                index - 1 + '-' + (i - 1)
                              ][0]
                            "
                          />
                        </div>
                        <div class="col-6 fs-13-label">
                          <label class="float-left">
                            {{
                              model.calification_type[
                                index - 1 + '-' + (i - 1)
                              ] == 'Texto'
                                ? `Max caracteres`
                                : `Máximo`
                            }}
                          </label>
                          <input
                            type="number"
                            class="form-control shadow-sm"
                            v-bind:step="`${
                              model.calification_type[
                                index - 1 + '-' + (i - 1)
                              ] == 'Texto'
                                ? `1`
                                : `.01`
                            }`"
                            v-bind:placeholder="`${
                              model.calification_type[
                                index - 1 + '-' + (i - 1)
                              ] == 'Texto'
                                ? `0`
                                : `0.0`
                            }`"
                            v-bind:min="`${
                              model.calification_type[
                                index - 1 + '-' + (i - 1)
                              ] == 'Texto'
                                ? 0
                                : ''
                            }`"
                            v-bind:ref="'maximum'"
                            v-model="
                              model.task_numeric_values[
                                index - 1 + '-' + (i - 1)
                              ][1]
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="text-center col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                      v-else-if="
                        model.calification_type[index - 1 + '-' + (i - 1)] ===
                        'Objetiva'
                      "
                    >
                      <div class="row" style="margin-top: 28px">
                        <div class="col-6">
                          <el-input value="Si" disabled> </el-input>
                        </div>
                        <div class="col-6">
                          <el-input value="No" disabled> </el-input>
                        </div>
                      </div>
                    </div>
                    <div
                      class="text-center col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                      v-else-if="
                        model.calification_type[index - 1 + '-' + (i - 1)] ===
                        'Subjetiva'
                      "
                    >
                      <div class="d-flex justify-content-between align-items-center w-100" style="margin-top: 28px;">
                        <el-tag type="info" disable-transitions style="width: 28%; height: 36px; line-height: 34px; font-size: 14px; text-align: center;">0</el-tag>
                        <span class="text-muted mx-1">...</span>
                        <el-tag type="info" disable-transitions style="width: 28%; height: 36px; line-height: 34px; font-size: 14px; text-align: center;">10</el-tag>
                        <span class="text-muted mx-1">...</span>
                        <el-tag type="info" disable-transitions style="width: 28%; height: 36px; line-height: 34px; font-size: 14px; text-align: center;">NA</el-tag>
                      </div>
                    </div>
                    <div
                      class="text-center col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                      v-else-if="
                        model.calification_type[index - 1 + '-' + (i - 1)] ===
                        'Subjetiva 2'
                      "
                    >
                      <div class="d-flex justify-content-between align-items-center w-100" style="margin-top: 28px;">
                        <el-tag type="info" disable-transitions style="width: 28%; height: 36px; line-height: 34px; font-size: 14px; text-align: center;">0</el-tag>
                        <span class="text-muted mx-1">...</span>
                        <el-tag type="info" disable-transitions style="width: 28%; height: 36px; line-height: 34px; font-size: 14px; text-align: center;">5</el-tag>
                        <span class="text-muted mx-1">...</span>
                        <el-tag type="info" disable-transitions style="width: 28%; height: 36px; line-height: 34px; font-size: 14px; text-align: center;">NA</el-tag>
                      </div>
                    </div>
                    <div
                      v-if="
                        model.calification_type[index - 1 + '-' + (i - 1)] ==
                        'Fecha'
                      "
                      class="col-xs-12 col-md-4 col-lg-4 col-xl-3"
                    ></div>
                    <div
                      v-if="
                        model.calification_type[index - 1 + '-' + (i - 1)] ==
                        'Hora'
                      "
                      class="col-xs-12 col-md-6 col-lg-4 col-xl-3"
                    ></div>
                    <div
                      class="col-xs-12 col-sm-6 col-md-2 col-lg-3 col-xl-1 text-left fs-13-label"
                      v-if="model.calification_type[index - 1 + '-' + (i - 1)] !== 'Fórmula'"
                    >
                      <fg-input
                        v-model="model.taskDcto[index - 1 + '-' + (i - 1)]"
                        type="number"
                        :label="$t('common_words.product_percentage')"
                        :placeholder="`0.0`"
                        min="0"
                        max="100"
                        step=".01"
                        name="common_words.discount_task_percentage_subcategory"
                        v-validate="modelValidations.taskDcto"
                        :error="
                          getError(
                            'common_words.discount_task_percentage_subcategory',
                            true,
                            {
                              '%1%': i,
                              '%2%': `&quot;${
                                model.sub_category_names[index - 1]
                              }&quot;`,
                            }
                          )
                        "
                      ></fg-input>
                    </div>
                    <div
                      class="col-xs-12 col-sm-6 col-md-2 col-lg-3 col-xl-1 text-left fs-13-label"
                      v-if="model.calification_type[index - 1 + '-' + (i - 1)] !== 'Fórmula'"
                    >
                      <fg-input
                        v-model="
                          model.taskPercentage[index - 1 + '-' + (i - 1)]
                        "
                        type="number"
                        :label="`${$t(
                          'common_words.value_percentage_symbol'
                        ).replace(/[()]/g, '')}`"
                        :placeholder="`0.0`"
                        min="0"
                        max="100"
                        step=".01"
                        name="common_words.value_percentual_task_subcategory"
                        v-validate="modelValidations.taskPercentage"
                        :error="
                          getError(
                            'common_words.value_percentual_task_subcategory',
                            true,
                            {
                              '%1%': i,
                              '%2%': `&quot;${
                                model.sub_category_names[index - 1]
                              }&quot;`,
                            }
                          )
                        "
                        @change="updateTaskPercentage(index - 1)"
                      ></fg-input>
                    </div>

                    <div class="col col-lg-1 col-xl-1 text-left fs-13-label" v-if="model.calification_type[index - 1 + '-' + (i - 1)] !== 'Fórmula'">
                      <label>{{ $t('common_words.photo_questionmark') }}</label>
                      <br />
                      <l-switch
                        class="mt-2"
                        style="display: block"
                        v-model="
                          model.photo_required[index - 1 + '-' + (i - 1)]
                        "
                        on-text="ON"
                        off-text="OFF"
                        :index="index - 1 + '-' + (i - 1)"
                      >
                      </l-switch>
                    </div>
                    <div class="col col-lg-1 col-xl-1 text-left fs-13-label" v-if="model.calification_type[index - 1 + '-' + (i - 1)] !== 'Fórmula'">
                      <label>{{ $t('common_words.required') }}?</label>
                      <br />
                      <l-switch
                        class="mt-2"
                        style="display: block"
                        v-model="model.is_required[index - 1 + '-' + (i - 1)]"
                        on-text="ON"
                        off-text="OFF"
                        :index="index - 1 + '-' + (i - 1)"
                      >
                      </l-switch>
                    </div>

                    <div
                      class="col-4"
                      v-if="
                        model.calification_type[index - 1 + '-' + (i - 1)] ===
                          'Subjetiva 2' ||
                        model.calification_type[index - 1 + '-' + (i - 1)] ===
                          'Subjetiva'
                      "
                    >
                      <div class="form-group has-label">
                        <label>{{ $t('audit.compliance_type') }}</label>
                        <br />
                        <el-select
                          filterable
                          class="select-default shadow-sm required-second-step"
                          v-model="
                            model.type_discount[index - 1 + '-' + (i - 1)]
                          "
                          :placeholder="`${$t('common_words.select')}...`"
                        >
                          <el-option
                            v-for="(option, key) in getTypeDiscount"
                            :key="key"
                            class="select-default"
                            :label="option.label"
                            :value="option.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div
                      class="col-8 text-center"
                      v-if="
                        model.calification_type[index - 1 + '-' + (i - 1)] ===
                          'Subjetiva 2' ||
                        model.calification_type[index - 1 + '-' + (i - 1)] ===
                          'Subjetiva'
                      "
                    >
                      <a
                        v-if="
                          model.type_discount[index - 1 + '-' + (i - 1)] !==
                          'Fijo'
                        "
                        v-tooltip.top-center="$t('audit.add_variable_discount')"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                        @click="
                          openDialog(index - 1, i - 1),
                            createSchemaForVariableDiscount(
                              index - 1 + '-' + (i - 1)
                            )
                        "
                      >
                        <i class="fa fa-percent custom-size-fa-actions pt-4"></i
                      ></a>
                      <el-dialog
                        :title="$t('audit.compliance_value')"
                        :visible.sync="dialogVisible[`${index - 1}-${i - 1}`]"
                        :show-close="false"
                        :close-on-click-modal="false"
                        :close-on-press-escape="false"
                        width="40%"
                      >
                        <div class="row">
                          <div class="col-6">
                            <p>{{ $t('common_words.value') }}</p>
                          </div>
                          <div class="col-6">
                            <p>{{ $t('common_words.compliance') }}</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 align-center-cell-flex">
                            <el-tag closable type="info"> 0 </el-tag>
                          </div>
                          <div class="col-6 align-center-cell-flex">
                            <fg-input
                              style="width: 75px"
                              type="number"
                              min="0"
                              step="0.001"
                              v-model="
                                model.discount_variable_subj[
                                  `${index - 1}-${i - 1}-0`
                                ]
                              "
                            ></fg-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 align-center-cell-flex">
                            <el-tag closable type="info"> 1 </el-tag>
                          </div>
                          <div class="col-6 align-center-cell-flex">
                            <fg-input
                              style="width: 75px"
                              type="number"
                              min="0"
                              step="0.001"
                              v-model="
                                model.discount_variable_subj[
                                  `${index - 1}-${i - 1}-1`
                                ]
                              "
                            ></fg-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 align-center-cell-flex">
                            <el-tag closable type="info"> 2 </el-tag>
                          </div>
                          <div class="col-6 align-center-cell-flex">
                            <fg-input
                              style="width: 75px"
                              type="number"
                              min="0"
                              step="0.001"
                              v-model="
                                model.discount_variable_subj[
                                  `${index - 1}-${i - 1}-2`
                                ]
                              "
                            ></fg-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 align-center-cell-flex">
                            <el-tag closable type="info"> 3 </el-tag>
                          </div>
                          <div class="col-6 align-center-cell-flex">
                            <fg-input
                              style="width: 75px"
                              type="number"
                              min="0"
                              step="0.001"
                              v-model="
                                model.discount_variable_subj[
                                  `${index - 1}-${i - 1}-3`
                                ]
                              "
                            ></fg-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 align-center-cell-flex">
                            <el-tag closable type="info"> 4 </el-tag>
                          </div>
                          <div class="col-6 align-center-cell-flex">
                            <fg-input
                              style="width: 75px"
                              type="number"
                              min="0"
                              step="0.001"
                              v-model="
                                model.discount_variable_subj[
                                  `${index - 1}-${i - 1}-4`
                                ]
                              "
                            ></fg-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 align-center-cell-flex">
                            <el-tag closable type="info"> 5 </el-tag>
                          </div>
                          <div class="col-6 align-center-cell-flex">
                            <fg-input
                              style="width: 75px"
                              type="number"
                              min="0"
                              step="0.001"
                              v-model="
                                model.discount_variable_subj[
                                  `${index - 1}-${i - 1}-5`
                                ]
                              "
                            ></fg-input>
                          </div>
                        </div>
                        <div
                          v-if="
                            model.calification_type[
                              index - 1 + '-' + (i - 1)
                            ] === 'Subjetiva'
                          "
                        >
                          <div class="row">
                            <div class="col-6 align-center-cell-flex">
                              <el-tag closable type="info"> 6 </el-tag>
                            </div>
                            <div class="col-6 align-center-cell-flex">
                              <fg-input
                                style="width: 75px"
                                type="number"
                                min="0"
                                step="0.001"
                                v-model="
                                  model.discount_variable_subj[
                                    `${index - 1}-${i - 1}-6`
                                  ]
                                "
                              ></fg-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6 align-center-cell-flex">
                              <el-tag closable type="info"> 7 </el-tag>
                            </div>
                            <div class="col-6 align-center-cell-flex">
                              <fg-input
                                style="width: 75px"
                                type="number"
                                min="0"
                                step="0.001"
                                v-model="
                                  model.discount_variable_subj[
                                    `${index - 1}-${i - 1}-7`
                                  ]
                                "
                              ></fg-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6 align-center-cell-flex">
                              <el-tag closable type="info"> 8 </el-tag>
                            </div>
                            <div class="col-6 align-center-cell-flex">
                              <fg-input
                                style="width: 75px"
                                type="number"
                                min="0"
                                step="0.001"
                                v-model="
                                  model.discount_variable_subj[
                                    `${index - 1}-${i - 1}-8`
                                  ]
                                "
                              ></fg-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6 align-center-cell-flex">
                              <el-tag closable type="info"> 9 </el-tag>
                            </div>
                            <div class="col-6 align-center-cell-flex">
                              <fg-input
                                style="width: 75px"
                                type="number"
                                min="0"
                                step="0.001"
                                v-model="
                                  model.discount_variable_subj[
                                    `${index - 1}-${i - 1}-9`
                                  ]
                                "
                              ></fg-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6 align-center-cell-flex">
                              <el-tag closable type="info"> 10 </el-tag>
                            </div>
                            <div class="col-6 align-center-cell-flex">
                              <fg-input
                                style="width: 75px"
                                type="number"
                                min="0"
                                step="0.001"
                                v-model="
                                  model.discount_variable_subj[
                                    `${index - 1}-${i - 1}-10`
                                  ]
                                "
                              ></fg-input>
                            </div>
                          </div>
                        </div>
                        <div v-if="isCreate() || isUpdate()">
                          <span slot="footer" class="dialog-footer">
                            <el-button
                              type="danger"
                              @click="handleCloseDialog(index - 1, i - 1)"
                              >{{ $t('common_words.exit') }}
                              {{ $t('common_words.and') }}
                              {{ $t('common_words.erase') }}
                            </el-button>
                            <el-button
                              type="primary"
                              @click="handleSaveDialog(index - 1, i - 1)"
                              >{{ $t('common_words.confirm') }}
                              {{ $t('common_words.and') }}
                              {{ $t('common_words.save') }}
                            </el-button>
                          </span>
                        </div>
                      </el-dialog>
                      <div
                        v-if="
                          model.type_discount[index - 1 + '-' + (i - 1)] !==
                          'Fijo'
                        "
                        class="px-0 mr-1"
                      >
                        <el-tooltip placement="top">
                          <div slot="content">
                            <p>
                              <strong>
                                {{ $t('audit.compliance_type') }}
                                :
                              </strong>
                              {{
                                model.type_discount[
                                  index - 1 + '-' + (i - 1)
                                ] == 'Variado'
                                  ? $t('audit.variable')
                                  : $t('audit.fixed')
                              }}
                            </p>
                            <div
                              v-for="(val, key) in getDiscountByTaskIndex(
                                index - 1 + '-' + (i - 1)
                              )"
                              :key="key"
                              v-if="
                                model.type_discount[
                                  index - 1 + '-' + (i - 1)
                                ] == 'Variado'
                              "
                            >
                              <p>
                                <strong>
                                  {{ $t('common_words.range') }}:
                                </strong>
                                {{ key }} -
                                <strong>
                                  {{ $t('common_words.value') }}:
                                </strong>
                                {{ val }}%
                              </p>
                            </div>
                          </div>
                          <a>
                            <em class="fa fa-eye custom-size-fa-actions"> </em>
                          </a>
                        </el-tooltip>
                      </div>
                    </div>

                    <div class="col-12 py-0"><hr /></div>
                  </div>
                </span>
              </div>
            </div>
          </card>
        </span>
      </div>
      <div class="col-1 p-0 text-center fixed-add-subcategory">
        <el-button
          :v-tooltip.top-left="$t('common_words.add_sub_category')"
          class="btn-info button-new-tag"
          size="small"
          icon="el-icon-plus"
          @click="addSubCategory"
        >
        </el-button>
        <el-button
          v-if="sub_number > 0"
          :v-tooltip.top-left="$t('common_words.delete_sub_category')"
          class="btn-info button-new-tag mt-1"
          size="small"
          icon="el-icon-minus"
          @click="minusSubCategory"
        >
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { convertFirstLetterUppercase } from 'src/util/Util.js';
import { Divider, Slider } from 'element-ui';
import { getRepeatsFromArray } from 'src/util/Util.js';
import { getSumOfValorFromArray } from 'src/util/Util.js';
import { isset, ifExistNumber } from 'src/util/Util';
import { Switch as LSwitch } from 'src/components';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinNumbers from 'src/util/mixinNumbers';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import store from '@/store';
import SweetAlert from 'src/class/Alerts.js';

export default {
  components: {
    [Divider.name]: Divider,
    [Slider.name]: Slider,
    LSwitch,
  },

  props: {
    generalTaskPercentage: {
      type: Number,
      default: 0,
    },
  },

  watch: {
    generalTaskPercentage(newValue) {
      Object.keys(this.model.taskDcto).forEach((index) => {
        if (!this.model.taskDcto[index])
          this.$set(this.model.taskDcto, index, newValue);
      });
    },
  },

  computed: {
    getTypeDiscount() {
      return [
        { id: 'Fijo', label: i18n.t('audit.fixed') },
        { id: 'Variado', label: i18n.t('audit.variable') },
      ];
    },
  },

  data() {
    return {
      formulaErrors: {},
      referenceErrors: {},
      taskNameErrors: {},
      model: {
        subcategoryOrder: [1],
        sub_category_names: [],
        isGeneral: [false],
        allowFormula: [false],
        valuePercentage: [0],
        sub_category_ids: [],
        tasks_number: [],
        task_ids: {},
        task_order: [],
        taskDcto: [],
        taskPercentage: [],
        task_names: {},
        is_required: {},
        photo_required: {},
        calification_type: {},
        task_values: [],
        task_numeric_values: [],
        data_source_selected: [],
        type_discount: [],

        reference_name: {},
        formula_expression: {},
        discount_variable_subj: {},
      },
      dialogVisible: {},
      index_numeric: 0,
      input_task_values: [],
      inputVisible: [],
      sub_number: 1,
      tasks_number_initial: [],
      initialLength: 1,
      initial_numeric_update: [],
      dataSources: [],
      modelValidations: {
        valuePercentage: {
          min_value: 0,
          max_value: 100,
        },
        taskDcto: {
          min_value: 0,
          max_value: 100,
        },
        taskPercentage: {
          min_value: 0,
          max_value: 100,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinNumbers, MixinValidations],
  methods: {
    getOptionsCalificationType(subcatIndex) {
      const options = [
        { id: 'Objetiva', label: i18n.t('common_words.objective_fem') },
        { id: 'Subjetiva', label: i18n.t('common_words.subjective_fem') },
        { id: 'Subjetiva 2', label: i18n.t('common_words.subjective_fem2') },
        { id: 'Numérica', label: i18n.t('common_words.numerical') },
        { id: 'Única', label: i18n.t('common_words.unique') },
        { id: 'Múltiple', label: i18n.t('common_words.multiple') },
        { id: 'Fuente de Datos', label: i18n.t('common_words.data_source') },
        { id: 'Texto', label: i18n.t('common_words.text') },
        { id: 'Fecha', label: i18n.t('common_words.date') },
        { id: 'Hora', label: i18n.t('common_words.hour') },
        {
          id: 'Fuente de Datos Múltiple',
          label: i18n.t('common_words.multiple_data_source'),
        },
      ];

      if (this.model && this.model.allowFormula && this.model.allowFormula[subcatIndex] === true) {
        options.push({ id: 'Fórmula', label: 'Fórmula' });
      }

      return options;
    },
    openDialog(index, i) {
      const key = `${index}-${i}`;
      this.$set(this.dialogVisible, key, true);
    },
    handleCloseDialog(index, i) {
      const key = `${index}-${i}`;
      if (this.model.type_discount && this.model.type_discount[key]) {
        this.model.type_discount[key] = 'Fijo';
      }
      if (this.model.discount_variable_subj) {
        Object.keys(this.model.discount_variable_subj).forEach((index) => {
          if (index.startsWith(`${key}-`)) {
            this.$delete(this.model.discount_variable_subj, index);
          }
        });
      }
      if (!this.dialogVisible[key]) return;

      this.$set(this.dialogVisible, key, false);
    },
    handleSaveDialog(index, i) {
      const key = `${index}-${i}`;
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          let isNotEmpty = true;
          const arrayDiscountSubj = Object.entries(
            this.model.discount_variable_subj
          );
          const arrayTypeDiscount = Object.entries(this.model.type_discount);
          for (const [keyDiscount, valueDiscount] of arrayTypeDiscount) {
            for (const [keyCompliance, valueCompliance] of arrayDiscountSubj) {
              if (
                keyCompliance.startsWith(`${keyDiscount}-`) &&
                valueDiscount == 'Variado'
              ) {
                if (!ifExistNumber(valueCompliance)) {
                  SweetAlert.warning(
                    i18n.t(
                      'sweet_alert.adv_audit.all_compliance_ranges_must_have_values'
                    )
                  );
                  isNotEmpty = false;
                  break;
                }
              }
              if (!isNotEmpty) {
                break;
              }
            }
          }

          if (isNotEmpty) {
            if (!this.dialogVisible[key]) return;

            this.$set(this.dialogVisible, key, false);
          }
        }
      });
    },
    createSchemaForVariableDiscount(key) {
      const type_discount = this.model.type_discount[key];
      if (type_discount == 'Variado') {
        const calification_type = this.model.calification_type[key];
        const length = calification_type == 'Subjetiva 2' ? 6 : 11;
        for (let index = 0; index < length; index++) {
          const newKey = key + '-' + index;
          if (this.model.discount_variable_subj[newKey] == undefined) {
            this.$set(this.model.discount_variable_subj, newKey, null);
          }
        }
      }
    },
    getDiscountByTaskIndex(taskIndex) {
      const arr = Object.entries(this.model.discount_variable_subj);
      let valueCompliance = {};
      for (const [keyDiscount, valueDiscount] of arr) {
        if (keyDiscount.startsWith(`${taskIndex}-`)) {
          valueCompliance[keyDiscount.split('-')[2]] = valueDiscount;
        }
      }

      return valueCompliance;
    },
    cleanStep() {
      this.model = {
        subcategoryOrder: [1],
        sub_category_names: [],
        isGeneral: [false],
        allowFormula: [false],
        valuePercentage: [0],
        sub_category_ids: [],
        tasks_number: [],
        task_ids: {},
        task_order: [],
        taskDcto: [],
        taskPercentage: [],
        task_names: {},
        is_required: {},
        photo_required: {},
        calification_type: {},
        task_values: [],
        task_numeric_values: [],
        data_source_selected: [],

        reference_name: {},
        formula_expression: {},
        type_discount: [],
        discount_variable_subj: {},
      };
      this.index_numeric = 0;
      this.input_task_values = [];
      this.inputVisible = [];
      this.sub_number = 1;
      this.tasks_number_initial = [];
      this.initialLength = 1;
      this.initial_numeric_update = [];
      this.dataSources = [];
    },

    updatePercentage() {
      const total = getSumOfValorFromArray(this.model.valuePercentage);
      const rest = this.model.valuePercentage.filter(
        (percentage) => !percentage
      );

      this.model.valuePercentage.forEach((percentage, index) => {
        if (!percentage) {
          const value = ((100 - total) / rest.length).toFixed(2);
          this.$set(
            this.model.valuePercentage,
            index,
            Number(value) < 0 ? 0 : Number(value)
          );
        }
      });
    },

    validatePercentage() {
      const total = getSumOfValorFromArray(this.model.valuePercentage);
      if (total.toFixed(2) < Number(100) || total.toFixed(2) > Number(100)) {
        SweetAlert.warning(
          `${i18n.t('sweet_alert.adv_audit.textpart1')} ${total.toFixed(2)}%`
        );
        return false;
      }

      return true;
    },

    updateTaskPercentage(indexSubCat) {
      const tmpPercentage = Object.entries(this.model.taskPercentage);
      const percentageBySubCat = tmpPercentage
        .filter((infoTask) => infoTask[0].startsWith(`${indexSubCat}-`))
        .map((infoTask) => infoTask[1]);

      const total = getSumOfValorFromArray(percentageBySubCat);
      const rest = tmpPercentage.filter(
        (infoTask) => infoTask[0].startsWith(`${indexSubCat}-`) && !infoTask[1]
      );

      percentageBySubCat.forEach((percentage, index) => {
        if (!percentage) {
          const value = ((100 - total) / rest.length).toFixed(2);
          this.$set(
            this.model.taskPercentage,
            `${indexSubCat}-${index}`,
            Number(value) < 0 ? 0 : Number(value)
          );
        }
      });
    },

    validateTaskPercentage() {
      const errors = this.model.sub_category_names.map((nameSubCat, index) => {
        const percentageBySubCat = Object.entries(this.model.taskPercentage)
          .filter((infoTask) => infoTask[0].startsWith(`${index}-`))
          .map((infoTask) => infoTask[1]);

        const total = getSumOfValorFromArray(percentageBySubCat);
        if (total.toFixed(2) !== Number(100).toFixed(2)) {
          return `${i18n.t(
            'sweet_alert.adv_audit.textpart2'
          )} "${nameSubCat}" ${i18n.t(
            'sweet_alert.adv_audit.textpart3'
          )} ${total.toFixed(2)}%`;
        }

        return true;
      });

      if (errors.every((error) => error === true)) return true;
      else {
        const errorMsg = errors.find((error) => error !== true);
        SweetAlert.warning(errorMsg);
      }
    },

    fillTableNameSelected(index) {
      const source = this.dataSources.filter(
        (item) => item.table_name === this.model.task_values[index][0]
      );
      try {
        this.model.data_source_selected[index] = source[0].label;
      } catch (error) {
        this.model.data_source_selected[index] = '';
      }
    },

    updateIndexCalificationType() {
      Object.entries(this.model.calification_type).filter(([key, value]) => {
        if (value == 'Numérica' || value == 'Texto') {
          this.model.task_numeric_values[key] = [
            this.model.task_numeric_values[key]
              ? this.model.task_numeric_values[key][0]
              : null,
            this.model.task_numeric_values[key]
              ? this.model.task_numeric_values[key][1]
              : null,
          ];
        } else if (this.model.task_numeric_values[key]) {
          delete this.model.task_numeric_values[key];
        }
        if (
          (value === 'Subjetiva 2' && !this.model.type_discount[key]) ||
          (value === 'Subjetiva' && !this.model.type_discount[key])
        ) {
          this.$set(this.dialogVisible, key, false);
          this.$set(this.model.type_discount, key, 'Fijo');
        }
      });
    },

    showRangeSelected(index) {
      try {
        return (
          'Min: ' +
          this.roundNumber(
            isNaN(this.model.task_numeric_values[index][0])
              ? 0
              : this.model.task_numeric_values[index][0],
            2
          ) +
          ' - Max: ' +
          this.roundNumber(
            isNaN(this.model.task_numeric_values[index][1])
              ? 0
              : this.model.task_numeric_values[index][1],
            2
          )
        );
      } catch (error) {
        return '';
      }
    },

    minusSubCategory() {
      this.$emit('showHideLoading', true);
      if (this.sub_number > 0) {
        this.sub_number--;
        const orderTmp = [...this.model.subcategoryOrder];
        orderTmp.pop();
        const value = [...this.model.valuePercentage];
        value.pop();
        this.$set(this.model, 'subcategoryOrder', orderTmp);
        this.$set(this.model, 'valuePercentage', value);
      }
      this.updateArrays(0);
      this.updateSubCat();
      this.updateOrderSubCat();
      setTimeout(() => {
        this.$emit('showHideLoading', false);
        if (this.sub_number == 0) {
          this.sub_number = 1;
          this.$set(this.model, 'subcategoryOrder', [1]);
        }
        this.updatePercentage();
      }, 200);
    },

    getAvailableReferences() {
      const refsMap = {};
      Object.keys(this.model.reference_name || {}).forEach(key => {
        const refValue = this.model.reference_name[key];
        if (refValue && !refsMap[refValue]) {
          refsMap[refValue] = this.model.task_names[key] || '';
        }
      });
      return Object.keys(refsMap).map(ref => ({
        name: ref,
        taskName: refsMap[ref]
      }));
    },

    insertIntoFormula(subcatIndex, taskIndex, text) {
      const key = subcatIndex + '-' + taskIndex;
      let current = this.model.formula_expression[key] || '';
      let newText = current + text;
      if (newText.includes('=')) {
        newText = newText.replace(/=/g, '');
      }
      this.$set(this.model.formula_expression, key, newText);
      this.validateFormula(newText, key);
    },

    validateAllTaskNames() {
      for (const key in this.model.task_names) {
        this.$set(this.taskNameErrors, key, null);
      }
      
      const countsBySubcat = {};
      
      for (const key in this.model.task_names) {
        let val = this.model.task_names[key];
        if (val && val.trim() !== '') {
          val = val.trim().toLowerCase();
          const subcatIndex = key.split('-')[0];
          
          if (!countsBySubcat[subcatIndex]) {
            countsBySubcat[subcatIndex] = {};
          }
          if (!countsBySubcat[subcatIndex][val]) {
            countsBySubcat[subcatIndex][val] = [];
          }
          countsBySubcat[subcatIndex][val].push(key);
        }
      }
      
      for (const subcat in countsBySubcat) {
        for (const val in countsBySubcat[subcat]) {
          if (countsBySubcat[subcat][val].length > 1) {
            countsBySubcat[subcat][val].forEach(key => {
              this.$set(this.taskNameErrors, key, 'Ya existe una tarea con este nombre en la categoría.');
            });
          }
        }
      }
    },

    validateAllReferences() {
      const counts = {};
      const reserved = ['SUM', 'AVERAGE', 'COUNT', 'COUNTA', 'COUNTIF', 'MAX', 'MIN', 'IF', 'PROMEDIO', 'CONTAR', 'CONTARA', 'CONTAR.SI', 'SI', 'MAXIMO', 'MINIMO', 'SUMAR.SI', 'SUMIF'];
      
      for (const key in this.model.reference_name) {
        let val = this.model.reference_name[key];
        this.$set(this.referenceErrors, key, null);
        if (val && val.trim() !== '') {
          val = val.trim().toUpperCase();
          if (!counts[val]) {
            counts[val] = [];
          }
          counts[val].push(key);
        }
      }
      
      for (const val in counts) {
        if (counts[val].length > 1) {
          counts[val].forEach(key => {
            this.$set(this.referenceErrors, key, 'Referencia duplicada.');
          });
        } else if (reserved.includes(val)) {
          counts[val].forEach(key => {
            this.$set(this.referenceErrors, key, 'Nombre reservado por el sistema.');
          });
        } else if (/[^a-zA-Z0-9_]/.test(counts[val][0] && this.model.reference_name[counts[val][0]])) {
          counts[val].forEach(key => {
            this.$set(this.referenceErrors, key, 'Solo letras, números y guión bajo.');
          });
        }
      }
    },

    validateFormula(text, key) {
      if (!text || text.trim() === '') {
        this.$set(this.formulaErrors, key, null);
        return;
      }
      
      let formula = text.trim();
      const validRefs = this.getAvailableReferences().map(r => r.name);
      
      validRefs.sort((a, b) => b.length - a.length);
      validRefs.forEach(ref => {
        const regex = new RegExp('\\b' + ref + '\\b', 'gi');
        formula = formula.replace(regex, '(1)');
      });

      // Permitir funciones comunes de Excel
      const excelFunctions = ['SUM', 'AVERAGE', 'COUNT', 'COUNTA', 'COUNTIF', 'MAX', 'MIN', 'IF', 'PROMEDIO', 'CONTAR', 'CONTARA', 'CONTAR.SI', 'SI', 'MAXIMO', 'MINIMO', 'SUMAR.SI', 'SUMIF'];
      excelFunctions.forEach(fn => {
        const regex = new RegExp('\\b' + fn + '\\b', 'gi');
        formula = formula.replace(regex, '1'); 
      });
      
      if (/[a-zA-Z_]/.test(formula)) {
        this.$set(this.formulaErrors, key, 'Contiene variables o funciones no reconocidas.');
        return;
      }
      
      // Permitir caracteres de Excel como , : " ' = < > %
      if (/[^0-9\+\-\*\/\(\)\.\s\,\:\"\'\=\<\>\%]/.test(formula)) {
        this.$set(this.formulaErrors, key, 'Contiene caracteres no permitidos (ej: corchetes [ ], llaves, etc).');
        return;
      }
      
      try {
        let formulaForEval = text.trim();
        validRefs.forEach(ref => {
          const regex = new RegExp('\\b' + ref + '\\b', 'gi');
          formulaForEval = formulaForEval.replace(regex, '(1)');
        });
        // Convertir funciones de Excel a una función de JS (Math.max) para que eval no falle
        formulaForEval = formulaForEval.replace(/\b[A-Za-z_.]+\s*\(/g, 'Math.max(');
        formulaForEval = formulaForEval.replace(/:/g, ',');
        formulaForEval = formulaForEval.replace(/["'][^"']*["']/g, '1');
        formulaForEval = formulaForEval.replace(/=/g, '===');
        formulaForEval = formulaForEval.replace(/<>/g, '!==');

        // eslint-disable-next-line
        eval(formulaForEval);
        this.$set(this.formulaErrors, key, null);
      } catch (e) {
        this.$set(this.formulaErrors, key, 'Error de sintaxis (revisa paréntesis u operadores).');
      }
    },

    addSubCategory() {
      this.sub_number++;
      this.nextNumberInOrder(this.model.subcategoryOrder);
      this.updateArrays(0);
      this.updateSubCat();
      this.updateOrderSubCat();

      this.$set(this.model, 'isGeneral', [...this.model.isGeneral, false]);
      this.$set(this.model, 'allowFormula', [...this.model.allowFormula, false]);
      this.$set(this.model, 'valuePercentage', [
        ...this.model.valuePercentage,
        null,
      ]);
      this.updatePercentage();
    },

    nextNumberInOrder(modelData) {
      const maxOrder = Math.max(...modelData);
      let result = Array.from(
        { length: isFinite(maxOrder) ? maxOrder : 1 },
        (v, i) => i + 1
      ).filter((element) => !modelData.includes(element));
      result = result.sort();

      if (result.length > 0) modelData.push(result[0]);
      else modelData.push(isFinite(maxOrder) ? maxOrder + 1 : 1);

      return modelData;
    },

    nextNumberInOrderTask(modelData, index, val) {
      const values = [];
      let actuallyValues = [];
      let a = 0;
      while (a < val) {
        const b = modelData[`${index}-${a}`];
        values.push(b ? b : val);
        if (b) actuallyValues[`${index}-${a}`] = b;
        a++;
      }

      const maxOrder = Math.max(...values);
      let result = Array.from(
        { length: isFinite(maxOrder) ? maxOrder : 1 },
        (v, i) => i + 1
      ).filter((element) => !Object.values(actuallyValues).includes(element));
      result = result.sort();

      if (result.length > 0)
        this.$set(modelData, `${index}-${val - 1}`, result[0]);
      else
        this.$set(
          modelData,
          `${index}-${val - 1}`,
          isFinite(maxOrder) ? maxOrder + 1 : val
        );

      return modelData;
    },

    minusTask(index) {
      if (this.model.tasks_number[index] == undefined) {
        this.$set(this.model.tasks_number, index, 0);
        this.$set(this.model, 'task_order', []);
      }

      if (this.model.tasks_number[index] > 0) {
        let val = this.model.tasks_number[index];
        let tmp = Object.assign([], this.model.task_order);
        delete tmp[`${index}-${val - 1}`];
        this.$set(this.model, 'task_order', tmp);

        tmp = Object.assign([], this.model.taskDcto);
        delete tmp[`${index}-${val - 1}`];
        this.$set(this.model, 'taskDcto', tmp);

        tmp = Object.assign([], this.model.taskPercentage);
        delete tmp[`${index}-${val - 1}`];
        this.$set(this.model, 'taskPercentage', tmp);

        val--;
        this.$set(this.model.tasks_number, index, val);
      }

      this.updateTasks(index);
      this.updateArrays(index, true);
      this.updateTaskPercentage(index);
    },

    addTask(index) {
      if (this.model.tasks_number[index] == undefined) {
        this.$set(this.model.tasks_number, index, 0);
      }

      let val = this.model.tasks_number[index];
      val++;
      this.$set(this.model.tasks_number, index, val);
      this.nextNumberInOrderTask(this.model.task_order, index, val);

      this.updateTasks(index);
      this.updateArrays(index, true);

      const tmpPercentage = { ...this.model.taskPercentage };
      tmpPercentage[`${index}-${val - 1}`] = null;
      this.$set(this.model, 'taskPercentage', tmpPercentage);

      const tmpDcto = { ...this.model.taskDcto };
      tmpDcto[`${index}-${val - 1}`] = this.generalTaskPercentage;
      this.$set(this.model, 'taskDcto', tmpDcto);

      this.updateTaskPercentage(index);
    },

    updateOrderTask(indexConcat) {
      return this.validateRepeated(
        this.model.task_order,
        Object.keys(this.model.task_order).length,
        true,
        indexConcat,
        'tarea',
        `'Orden de la tarea'`
      );
    },

    handleClose(tag, index) {
      this.model.task_values[index].splice(
        this.model.task_values[index].indexOf(tag),
        1
      );
    },

    handleInputConfirm(index) {
      let inputValue = this.input_task_values[index].trim();
      if (inputValue) {
        if (this.model.task_values[index] == undefined) {
          this.$set(this.model.task_values, index, []);
        }
        this.model.task_values[index].push(inputValue);
        this.model.task_values = { ...this.model.task_values };
      }
      this.inputVisible[index] = false;
      this.input_task_values[index] = '';
    },

    showInput(index) {
      this.inputVisible[index] = true;
      this.inputVisible = { ...this.inputVisible };
    },

    isVisible(index) {
      this.inputVisible[index];
      return this.inputVisible[index];
    },

    getTaskValues(index) {
      return this.model.task_values[index];
    },

    validateRepeated(
      list,
      length,
      isObject = false,
      indexConcat = 0,
      type = 'tarea',
      fieldMessage = `${i18n.t('common_words.name_of_the')} ${type}`
    ) {
      let a = 0;
      let b = 0;
      let c = 0;
      let d = 0;
      let num = 0;

      while (a < length) {
        const isTaskType = type == 'tarea' ? '-' : '';
        b = list[isObject ? indexConcat + isTaskType + a : a];
        if (typeof b === 'string') b = b.trim();
        c = 0;
        while (c < length) {
          d = list[isObject ? indexConcat + isTaskType + c : c];
          if (typeof d === 'string') d = d.trim();
          if (d && b === d) {
            num++;
          }

          if (num > 1) {
            SweetAlert.warning(
              `${i18n.t('sweet_alert.adv_audit.textpart4')} ${d} ${i18n.t(
                'sweet_alert.adv_audit.textpart5'
              )} ${fieldMessage}`
            );
            return true;
          }
          c++;
        }
        a++;
        num = 0;
      }

      return false;
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.model.task_numeric_values = Object.assign(
            {},
            this.model.task_numeric_values
          );
          this.model.task_values = { ...this.model.task_values };
          this.model.task_order = { ...this.model.task_order };
          this.model.taskDcto = { ...this.model.taskDcto };
          this.model.taskPercentage = { ...this.model.taskPercentage };
          this.model.type_discount = { ...this.model.type_discount };

          this.model.reference_name = { ...this.model.reference_name };
          this.model.formula_expression = { ...this.model.formula_expression };

          Object.keys(this.model.task_names).forEach((key) => {
            if (this.model.is_required[key] === undefined)
              this.model.is_required[key] = false;
            if (this.model.photo_required[key] === undefined)
              this.model.photo_required[key] = false;

          });
          this.$emit('on-validated', res, this.model);
          this.$emit('fillAdvancedAuditForm', 'secondStep', {
            user_id: this.$store.state.auth.user.id,
          });

          return res;
        })
        .then((response) => {
          if (!response) return response;

          return store
            .dispatch('utils/validationInputsRequired', '-second-step')
            .then(() => {
              if (!this.validatePercentage()) return false;
              if (!this.updateOrderSubCat()) return false;
              if (
                this.validateRepeated(
                  this.model.sub_category_names,
                  this.model.sub_category_names.length,
                  false,
                  0,
                  i18n.t('common_words.sub_category_unique')
                )
              ) {
                return false;
              }

              this.validateAllTaskNames();
              if (Object.keys(this.taskNameErrors).some(k => this.taskNameErrors[k])) {
                return false;
              }

              for (
                let index = 0;
                index < this.model.sub_category_names.length;
                index++
              ) {
                if (this.updateOrderTask(index)) return false;

                let keysTaskNames = Object.keys(
                  this.model.task_names
                ).toString();
                if (!keysTaskNames.includes(index + '-')) {
                  SweetAlert.warning(
                    `${i18n.t('common_words.sub_category_warning')} ${
                      this.model.sub_category_names[index]
                    }.`
                  );
                  return false;
                }
              }

              if (!this.validateTaskPercentage()) return false;

              for (const key in this.model.calification_type) {
                if (
                  Object.hasOwnProperty.call(this.model.calification_type, key)
                ) {
                  const element = this.model.calification_type[key];
                  if (
                    ([
                      'Única',
                      'Múltiple',
                      'Fuente de Datos',
                      'Fuente de Datos Múltiple',
                    ].includes(element) &&
                      (!this.model.task_values[key] ||
                        (this.model.task_values[key] &&
                          this.model.task_values[key].length == 0))) ||
                    (['Numérica', 'Texto'].includes(element) &&
                      (!this.model.task_numeric_values[key] ||
                        (this.model.task_numeric_values[key] &&
                          (!this.model.task_numeric_values[key][0] ||
                            !this.model.task_numeric_values[key][1] ||
                            (this.model.task_numeric_values[key][0] &&
                              this.model.task_numeric_values[key][0].length ==
                                0) ||
                            (this.model.task_numeric_values[key][1] &&
                              this.model.task_numeric_values[key][1].length ==
                                0)))))
                  ) {
                    SweetAlert.warning(
                      i18n.t('sweet_alert.adv_audit.textpart6') +
                        this.model.task_names[key] +
                        i18n.t('sweet_alert.adv_audit.textpart7') +
                        element +
                        i18n.t('sweet_alert.adv_audit.textpart8')
                    );
                    return false;
                  }
                }
              }

              return true;
            });
        });
    },

    updateTasks(indexConcat) {
      Object.keys(this.model.task_names).forEach((key) => {
        const value = this.model.task_names[key];
        if (typeof value === 'string') {
          this.$set(
            this.model.task_names,
            key,
            convertFirstLetterUppercase(value)
          );
        }
      });
      this.validateAllTaskNames();
    },

    updateSubCat() {
      this.model.sub_category_names = this.model.sub_category_names.map(
        (name) => convertFirstLetterUppercase(name)
      );
      this.validateRepeated(
        this.model.sub_category_names,
        this.model.sub_category_names.length,
        false,
        0,
        'subcategoría'
      );
    },

    updateOrderSubCat() {
      const result = getRepeatsFromArray(this.model.subcategoryOrder);
      if (result.length > 0) {
        SweetAlert.warning(
          `${i18n.t('sweet_alert.adv_audit.textpart9')} ${result[0]} ${i18n.t(
            'sweet_alert.adv_audit.textpart10'
          )} `
        );
        return false;
      }
      return true;
    },

    deleteNotCoincidence(data, index) {
      let toDelete = [];
      data.forEach((element) => {
        if (!(element + '').startsWith(index + '-')) {
          toDelete.push(data.indexOf(element + ''));
        }
      });

      toDelete.sort(function (x, y) {
        return y - x;
      });

      toDelete.forEach((i) => {
        data.splice(i, 1);
      });

      return data;
    },

    updateArrays(index, isObject = false) {
      let tmp = isObject
        ? this.deleteNotCoincidence(Object.keys(this.model.task_names), index)
        : null;

      if (isObject) {
        this.deleteNotCoincidence(Object.keys(this.model.task_ids), index);
      }

      let ln =
        (isObject ? tmp.length : this.model.sub_category_names.length) -
        (isObject ? this.model.tasks_number[index] : this.sub_number);

      if (ln > 0) {
        if (isObject) {
          let numberTasks = this.model.tasks_number[index];
          let numberInitial = this.tasks_number_initial[index] || 0;

          if (
            ln == 1 &&
            (numberTasks > numberInitial ||
              (numberTasks == numberInitial && tmp.length > numberInitial) ||
              numberTasks < numberInitial)
          ) {
            let i = index + '-' + numberTasks;
            delete this.model.task_ids[i];
            delete this.model.task_names[i];
            delete this.model.taskDcto[i];
            delete this.model.taskPercentage[i];
            delete this.model.is_required[i];
            delete this.model.photo_required[i];
            delete this.model.calification_type[i];
            delete this.model.task_values[i];
            delete this.model.task_numeric_values[i];
          } else if (ln > 1) {
            for (let i = this.tasks_number_initial[index]; i < ln; i++) {
              let j = index + '-' + (i - 1);
              delete this.model.task_ids[j];
              delete this.model.task_names[j];
              delete this.model.taskDcto[j];
              delete this.model.taskPercentage[j];
              delete this.model.is_required[j];
              delete this.model.photo_required[j];
              delete this.model.calification_type[j];
              delete this.model.task_values[j];
              delete this.model.task_numeric_values[j];
            }
          }
        } else {
          if (
            ln == 1 &&
            (this.sub_number > this.initialLength ||
              (this.sub_number == this.initialLength &&
                this.model.sub_category_names.length > this.initialLength) ||
              this.sub_number < this.initialLength)
          ) {
            let k = this.model.sub_category_names.length - 1;

            for (let i = 0; i < this.model.tasks_number[k]; i++) {
              let j = k + '-' + i;
              delete this.model.task_ids[j];
              delete this.model.task_names[j];
              delete this.model.taskDcto[j];
              delete this.model.taskPercentage[j];
              delete this.model.is_required[j];
              delete this.model.photo_required[j];
              delete this.model.calification_type[j];
              delete this.model.task_values[j];
              delete this.model.task_numeric_values[j];
            }

            this.model.sub_category_ids.pop();
            this.model.sub_category_names.pop();
            this.model.isGeneral.pop();
            this.model.allowFormula.pop();
            this.model.valuePercentage.pop();
            this.model.tasks_number.pop();
          } else if (ln > 1) {
            for (let j = ln; j > 0; j--) {
              for (let i = 0; i < this.model.tasks_number[j]; i++) {
                let l = j + '-' + i;
                delete this.model.task_ids[l];
                delete this.model.task_names[l];
                delete this.model.taskDcto[l];
                delete this.model.taskPercentage[l];
                delete this.model.is_required[l];
                delete this.model.photo_required[l];
                delete this.model.calification_type[l];
                delete this.model.task_values[l];
                delete this.model.task_numeric_values[l];
              }
            }

            this.model.sub_category_ids.splice(this.initialLength, ln);
            this.model.sub_category_names.splice(this.initialLength, ln);
            this.model.isGeneral.splice(this.initialLength, ln);
            this.model.allowFormula.splice(this.initialLength, ln);
            this.model.valuePercentage.splice(this.initialLength, ln);
            this.model.tasks_number.splice(this.initialLength, ln);
          }
        }
      }
    },
  },

  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      try {
        this.$refs.minimum.forEach((_, index) => {
          this.$refs.minimum[index].value =
            this.initial_numeric_update[index][0];
          this.$refs.maximum[index].value =
            this.initial_numeric_update[index][1];
        });
        this.updateIndexCalificationType();
      } catch (error) {}
    }
  },

  created() {
    let editForm = {};
    Axios.getMasters('quality/data/sources')
      .then((response) => {
        this.dataSources = response.data.data;
      })
      .catch((error) => this.showMessageErrors(error));

    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.subcategoryOrder = editForm.sub_category_order;
      this.model.sub_category_names = editForm.sub_category_names;
      this.model.isGeneral = editForm.generals;
      this.model.allowFormula = editForm.allow_formulas || Array.from({ length: editForm.sub_category_ids.length }, () => false);
      this.model.valuePercentage = editForm.valuesPercentages;
      this.model.sub_category_ids = editForm.sub_category_ids;
      this.sub_number = editForm.sub_category_ids.length;
      this.initialLength = editForm.sub_category_ids.length;
      let tmp = editForm.task_names;
      let tmp_calification_type = editForm.calification_type;
      let tmpids = editForm.task_ids;
      let tmporder = editForm.task_order;
      let tmpDcto = editForm.task_dcto;
      let tmpPercentage = editForm.task_percentage;
      let tmpDiscountType = editForm.task_discount_type;
      let tmpDiscountValues = editForm.task_discount_value;
      let i_numeric_ref = 0;
      editForm.sub_category_names.forEach((_, index) => {
        this.model.tasks_number.push(
          editForm.sub_categories[index].audit_tasks.length
        );
        this.tasks_number_initial.push(
          editForm.sub_categories[index].audit_tasks.length
        );

        let len = this.model.tasks_number[index];

        for (let i = 0; i < tmp.length; i++) {
          let items = tmp[i];
          let items_calification_type = tmp_calification_type[i];
          let itemsIds = tmpids[i];
          let itemsOrder = tmporder[i];
          let itemsDcto = tmpDcto[i];
          let itemsPercentage = tmpPercentage[i];
          if (i >= len) {
            if (len - 1 == 0) {
              tmp.shift();
              tmp_calification_type.shift();
              tmpids.shift();
              tmporder.shift();
              tmpDcto.shift();
              tmpPercentage.shift();
            } else {
              tmp.splice(0, len);
              tmp_calification_type.splice(0, len);
              tmpids.splice(0, len);
              tmporder.splice(0, len);
              tmpDcto.splice(0, len);
              tmpPercentage.splice(0, len);
            }
            break;
          }

          let id = editForm.sub_categories[index].id;
          if (items[id]) {
            this.$set(this.model.task_names, index + '-' + i, items[id]);
            this.$set(
              this.model.is_required,
              index + '-' + i,
              items_calification_type['is_required'] === 1 ? true : false
            );
            this.$set(
              this.model.photo_required,
              index + '-' + i,
              items_calification_type['photo_required'] === 1 ? true : false
            );
            this.$set(this.model.task_ids, index + '-' + i, itemsIds[id]);
            this.$set(this.model.task_order, index + '-' + i, itemsOrder[id]);
            this.$set(this.model.taskDcto, index + '-' + i, itemsDcto[id]);
            this.$set(
              this.model.taskPercentage,
              index + '-' + i,
              itemsPercentage[id]
            );

            this.$set(
              this.model.calification_type,
              index + '-' + i,
              items_calification_type[id]
            );


            this.$set(
              this.model.reference_name,
              index + '-' + i,
              items_calification_type['reference_name'] || null
            );
            this.$set(
              this.model.formula_expression,
              index + '-' + i,
              items_calification_type['formula_expression'] || null
            );

            switch (items_calification_type[id]) {
              case 'Numérica':
                this.$set(this.model.task_numeric_values, index + '-' + i, [
                  items_calification_type['minimum'],
                  items_calification_type['maximum'],
                ]);
                this.initial_numeric_update[i_numeric_ref] = [
                  items_calification_type['minimum'],
                  items_calification_type['maximum'],
                ];
                i_numeric_ref++;
                break;

              case 'Texto':
                this.$set(this.model.task_numeric_values, index + '-' + i, [
                  items_calification_type['minimum'],
                  items_calification_type['maximum'],
                ]);
                this.initial_numeric_update[i_numeric_ref] = [
                  items_calification_type['minimum'],
                  items_calification_type['maximum'],
                ];
                i_numeric_ref++;
                break;

              case 'Única':
              case 'Múltiple':
              case 'Fuente de Datos':
              case 'Fuente de Datos Múltiple':
                this.$set(
                  this.model.task_values,
                  index + '-' + i,
                  items_calification_type['task_values']
                );

                if (
                  items_calification_type[id] === 'Fuente de Datos' ||
                  items_calification_type[id] === 'Fuente de Datos Múltiple'
                ) {
                  this.$set(
                    this.model.data_source_selected,
                    index + '-' + i,
                    items_calification_type['data_source_label']
                  );
                }

                break;
            }
            if (Array.isArray(tmpDiscountType) && tmpDiscountType.length > 0) {
              let discountIndex = tmpDiscountType.findIndex(
                (obj) => obj[id] !== undefined
              );
              if (discountIndex !== -1) {
                const discountTypeObj = tmpDiscountType.splice(
                  discountIndex,
                  1
                )[0];
                const discountType = discountTypeObj[id];
                this.$set(
                  this.model.type_discount,
                  index + '-' + i,
                  discountType
                );
              }
            }
            if (
              Array.isArray(tmpDiscountValues) &&
              tmpDiscountValues.length > 0
            ) {
              let discountValueIndex = tmpDiscountValues.findIndex(
                (obj) => obj[id] !== undefined
              );

              if (discountValueIndex !== -1) {
                const discountValueObj = tmpDiscountValues.splice(
                  discountValueIndex,
                  1
                )[0];
                const discounts = discountValueObj[id];

                if (Array.isArray(discounts)) {
                  discounts.forEach((discountEntry) => {
                    const key = `${index}-${i}-${discountEntry.range}`;
                    this.$set(
                      this.model.discount_variable_subj,
                      key,
                      discountEntry.discount
                    );
                  });
                }
              }
            }
          }
        }
      });
    }
  },
};
</script>
<style scope>
.custom-audit-card .card-body {
  padding: 20px !important;
}

.input-new-tag {
  width: auto !important;
}
</style>
